export const ADD_CHAT_ACTION = "CHATS::ADD_CHAT_ACTION";
export const DELETE_CHAT_ACTION = "CHATS::DELETE_CHAT_ACTION";
export const UPDATE_CHAT_ACTION = "CHATS::UPDATE_CHAT_ACTION";
